import { call, put, takeEvery, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { createBidApi, createmultiBidApi, getMsgsCountApi } from "../../API/API";

function* CreateBidSaga(params) {
  try {
    const response = yield call(createBidApi, params);
    if (response) {
        yield put({ type: types.CREATE_BID_SUCCESS, payload: response.data });
        if(response.status == 200){
          const bids = {payload:{bids:[params.payload]}};
          yield put({type: types.Remove_Bidded_skillListings, payload:bids});
        }
    }
  } catch (error) {
    yield put({ type: types.CREATE_BID_FAILURE, error });
  }
}

export function* watchCreateBidSaga() {
  //added the take leading in watch create bid saga
  yield takeLeading(types.CREATE_BID_REQUESTED, CreateBidSaga);
}

// welfkel

function* createmultiBidSaga(params) {
  try {
    const response = yield call(createmultiBidApi, params);

    // API Backend
    yield put({ type: types.CREATE_MULTI_BID_SUCCESS, payload: response?.data?.data });
    if(response.status == 200){
      yield put({type: types.Remove_Bidded_skillListings, payload:params})
    }
  } catch (error) {
    yield put({ type: types.CREATE_MULTI_BID_FAILURE, error });
  }
}

export function* watchCreatemultiBidSaga() {
  yield takeEvery(types.CREATE_MULTI_BID_REQUESTED, createmultiBidSaga);
}
